import React from 'react';

const PopupLoadingScreen = () => {
    return (
        <div className="popup-loading-container">
            <div className="popup-loading-text">
                Loading...
            </div>
        </div>
    );
};

export default PopupLoadingScreen;